// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from "firebase/app";
import { getAuth, browserSessionPersistence, setPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';// TODO: Add SDKs for Firebase products that you want to use// TODO: Add SDKs for Firebase products that you want to use
import { getStorage } from "firebase/storage";
import { getFunctions } from 'firebase/functions';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDJCJi2x032gnOgfZhqVnw3etLI2mve8QU",
  authDomain: "up-convert.firebaseapp.com",
  projectId: "up-convert",
  storageBucket: "up-convert.firebasestorage.app",
  messagingSenderId: "907584193874",
  appId: "1:907584193874:web:08f7ab9a885e7d1b21a68b",
  measurementId: "G-YVD2NVV51S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Secondary auth instance for provisioning users without affecting current session
const provisionApp = getApps().find((a) => a.name === 'provision') || initializeApp(firebaseConfig, 'provision');
const provisionAuth = getAuth(provisionApp);

setPersistence(auth, browserSessionPersistence);
export { app, db, auth, storage, functions, provisionAuth };
